module.exports = __webpack_public_path__ + "static/media/noun_burger_menu_898763.2b7ce2fc.svg";